/* unplugin-vue-components disabled */import { render } from "./InstallInfo.vue?vue&type=template&id=fa73e16e&scoped=true"
import script from "./InstallInfo.vue?vue&type=script&lang=js"
export * from "./InstallInfo.vue?vue&type=script&lang=js"

import "./InstallInfo.vue?vue&type=style&index=0&id=fa73e16e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa73e16e"]])

export default __exports__